import { useNavigate } from 'react-router-dom';
import { localiseDigits } from '@bookingdei/i18n/format-number';
import { useLanguage } from './language-context';
import { usePlan } from './plan-context';
import { Sheet } from './sheet';
import { NavIcon } from './nav-icon';
import { visibleNavItems, isLocked } from './nav-items';

// The mobile More sheet (design M:3922-3945; CB-17 `more-sheet.tsx`, replaces the
// folded screens/more/ page): every page that is not one of the bar's three page
// slots — My Business, Offers, Promote, Insights, Team, My Plan, Account, then Inbox
// and QR studio (DR-37) — with lock glyphs (FR-B22), the "Soon" chip on deferred
// Promote and badges.
export function MoreSheet({
  open,
  onClose,
  isStaff,
  pending,
}: {
  open: boolean;
  onClose: () => void;
  isStaff: boolean;
  pending: number;
}) {
  const { lang, t } = useLanguage();
  const { entitlements } = usePlan();
  const navigate = useNavigate();
  const items = visibleNavItems(isStaff).filter((i) => !i.slot);
  return (
    <Sheet open={open} onClose={onClose} title={t('dc70.nav.more')}>
      <ul className="more-list" data-shell="more-sheet">
        {items.map((item) => {
          const locked = isLocked(item, entitlements);
          const badge = item.badge === 'pending_proofs' ? pending : 0;
          return (
            <li key={item.to}>
              <button
                type="button"
                className="more-list__row"
                onClick={() => {
                  onClose();
                  navigate(item.to);
                }}
                data-nav={item.to}
              >
                <span className="more-list__icon">
                  <NavIcon name={item.icon} size={16} strokeWidth={2} />
                </span>
                <span className="more-list__label">{t(item.key)}</span>
                {locked && (
                  <span className="more-list__lock" title={t('dc70.nav.locked')}>
                    <NavIcon name="lock" size={14} strokeWidth={1.75} />
                    <span className="visually-hidden">{t('dc70.nav.locked')}</span>
                  </span>
                )}
                {item.deferred && <span className="more-list__soon">{t('dc70.nav.soon')}</span>}
                {badge > 0 && (
                  <span className="more-list__badge">{localiseDigits(lang, badge)}</span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </Sheet>
  );
}
